import React from "react";
import { FaWhatsapp, FaMicrosoft } from "react-icons/fa";

/**
 * ChannelSelector - Kanal seçim bileşeni
 * Radio button mantığında çalışır. Sadece bir kanal seçilebilir.
 * 
 * @param {string} value - Seçili kanal: "whatsapp" | "teams"
 * @param {function} onChange - (value: "whatsapp" | "teams") => void
 */
const ChannelSelector = ({ value, onChange }) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      {/* WhatsApp Button */}
      <button
        type="button"
        onClick={() => onChange("whatsapp")}
        className={`p-4 rounded-xl border text-left transition-all flex items-center gap-3 ${
          value === "whatsapp"
            ? "border-green-500 bg-green-50"
            : "border-gray-200 bg-white hover:bg-gray-50"
        }`}
      >
        <FaWhatsapp
          className={`flex-shrink-0 ${
            value === "whatsapp" ? "text-green-500" : "text-gray-400"
          }`}
          size={24}
        />
        <div>
          <div
            className={`font-semibold ${
              value === "whatsapp" ? "text-gray-900" : "text-gray-800"
            }`}
          >
            WhatsApp
          </div>
          <div className="text-sm text-gray-600 mt-1">
            Sadece WhatsApp üzerinden gönder
          </div>
        </div>
      </button>

      {/* Microsoft Teams Button */}
      <button
        type="button"
        onClick={() => onChange("teams")}
        className={`p-4 rounded-xl border text-left transition-all flex items-center gap-3 ${
          value === "teams"
            ? "border-blue-500 bg-blue-50"
            : "border-gray-200 bg-white hover:bg-gray-50"
        }`}
      >
        <FaMicrosoft
          className={`flex-shrink-0 ${
            value === "teams" ? "text-blue-500" : "text-gray-400"
          }`}
          size={24}
        />
        <div>
          <div
            className={`font-semibold ${
              value === "teams" ? "text-gray-900" : "text-gray-800"
            }`}
          >
            Microsoft Teams
          </div>
          <div className="text-sm text-gray-600 mt-1">
            Sadece Teams üzerinden gönder
          </div>
        </div>
      </button>
    </div>
  );
};

export default ChannelSelector;
